import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Collapsible from "react-collapsible";
//import Icon from "../Icon";
import { formatUrl } from "../../util/format-url";

export default function Navigation(props: any) {
  let navigate = useNavigate();
  const [navExpanded] = useState(true);

  const selectPage = (page: any, menuType: string) => {
    if (page) {
      var tempPagesContent: any = props.pagesContent;
      var selectedPage: any = tempPagesContent[page];
      props.getPageContent(page, selectedPage);
      if (menuType === "menu-group") {
        navigate(`/${page}`);
      }
    }
  };

  /*const handleExpandNav = (prevState: boolean) => {
    if (prevState) {
      setNavExpanded(false);
    } else {
      setNavExpanded(true);
    }
  };*/

  var { navList } = props;
  //var { isDarkMode } = props;
  //console.log("navList", navList, "activatePageTitle", props.activatePageTitle);

  return (
    <>
      {navList && navList.length > 0 && (
        <>
          {/* <div className="expand-nav-div">
            <span
              className="expand-nav-control"
              onClick={() => handleExpandNav(navExpanded)}
            >
              {navExpanded ? "Collapse All" : "Expand All"}
            </span>
          </div> */}
          {navList.map(
            (item: any) =>
              !item.hide && (
                <div
                  className="level-1-nav"
                  key={`level-1-nav-${item.name}`}
                  onClick={(e: any) => selectPage(item.page, "menu-group")}
                >
                  <Collapsible
                    open={navExpanded}
                    transitionTime={200}
                    easing={"ease"}
                    trigger={
                      <div
                        className="level-1-nav-item"
                        key={`level-1-nav-item-${item.name}`}
                      >
                        {/* <span
                      className={isDarkMode ? "span-icon dark" : "span-icon"}
                    >
                      <img
                        src={item.icon}
                        className="icon"
                        alt=""
                        width=""
                        height=""
                      />
                    </span> */}
                        <span className="name">{item.name}</span>
                        {/* {item.items && item.items.length > 0 && (
                      <span className="collapse">
                        <Icon name="arrow" />
                      </span>
                    )} */}
                      </div>
                    }
                  >
                    {item.items && item.items.length > 0 && (
                      <div
                        className="level-2-nav"
                        key={`level-2-nav-${item.name}`}
                      >
                        {item.items.map((page: any) => (
                          <Link
                            className={
                              props.activatePageTitle === page.name
                                ? "level-2-nav-item is-active"
                                : "level-2-nav-item"
                            }
                            key={`level-2-nav-item-${page.name}`}
                            onClick={(e: any) =>
                              selectPage(page.name, "menu-item")
                            }
                            to={`/${formatUrl(item.name)}/${formatUrl(
                              page.name
                            )}`}
                          >
                            {page.name}
                          </Link>
                        ))}
                      </div>
                    )}
                    <div>
                      <br />
                    </div>
                  </Collapsible>
                </div>
              )
          )}
        </>
      )}
    </>
  );
}
